/* eslint-disable class-methods-use-this */
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { API } from "aws-amplify";
import { CSSTransition } from "react-css-transition";
import {
  injectIntl,
  FormattedMessage,
  FormattedDate,
  FormattedTime
} from "react-intl";
import DatePicker from 'react-datepicker';
import {da, enGB} from "date-fns/locale"

// NOTE: react-datepicker.css + react-datepicker-overrides.css is duplicated on Grav site <head> as including it here did not play way well with the way react app has been integrated with Grav
import 'react-datepicker/dist/react-datepicker.css';
import '../css/react-datepicker-overrides.css';

// import Dropdown from "../components/Dropdown";
import Spinner from "../components/Spinner";
import TransitionStyles from "../lib/transitionStyles";
import QuartersRow from "../components/timeSlotSelector/WhenQuartersRow";
import BookingLib, { calculateHoursCount } from "../lib/booking";
import Utils from '../lib/utils'


const DatepickerInput = React.forwardRef((props, ref) => (
  <input type="text" ref={ref} {...props} readOnly />
))

class TimeSlotSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workingHours: [],
      showConflictValidationError: false,
      showOutOfTimeBoundsError: false,
      showValidationError: false,
      showDateValidationError: false,
      showDayClosedError: false,
      // showExceedFutureLimitError: false,
      bookingDate: null,
      hoursCount: 1,
      selectedTimeEdited: false
    };

    const { whenStartTime, whenEndTime } = props.booking;
    if (whenStartTime && whenEndTime) {
      this.state = {
        ...this.state,
        bookingDate: new Date(whenStartTime),
        hoursCount: calculateHoursCount(whenStartTime, whenEndTime)
      };
    }

    // eslint-disable-next-line no-undef
    // this.CAPACITY = process.env.REACT_APP_CPHILL_ENV === 'production' ? 150 : 3
    this.CAPACITY = props.capacityLimit
    this.selectedTimeChanged = this.selectedTimeChanged.bind(this)
    this.onChange = this.onChange.bind(this)
    this.showConflictValidationError = this.showConflictValidationError.bind(this)
    this.isClosedDay = this.isClosedDay.bind(this)
    this.renderDayContents = this.renderDayContents.bind(this)
    this.isFutureDay = this.isFutureDay.bind(this)
  }

  componentDidMount() {
    const { state } = this
        
    if (state.bookingDate) {
      this.fetchBookingOverview(state.bookingDate)
    }
  }

  componentWillReceiveProps(nextProps) {
    const {showTimeSlotNotSelectedError} = this.props
    if (showTimeSlotNotSelectedError !== nextProps.showTimeSlotNotSelectedError) {
      this.setState({ showTimeSlotNotSelectedError: nextProps.showTimeSlotNotSelectedError })
    }
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleDateChange(date) {
    const { props } = this
    this.setState({
      selectedTimeEdited: true,
      bookingDate: date
    }, () => this.fetchBookingOverview(date))
    
    props.selectedTimeChanged(null, null)
    props.selectedDateChanged(date)
  }

  selectedTimeChanged(startTime) {
    const { props } = this;
    const { hoursCount } = this.state;

    let endTime = null;
    if (startTime && hoursCount) {
      endTime = new Date(startTime);
      endTime.setHours(endTime.getHours() + parseInt(hoursCount, 10));

      // After adding hours count to calculate endTime, 
      // make sure it doesn't flip to the next day 
      const sameDay = BookingLib.sameDay(startTime, endTime)

      this.setState({
        showOutOfTimeBoundsError: !sameDay || BookingLib.timeIsOutOfBounds(
          endTime,
          props.workingHours,
          props.overrideHours
        ),
        selectedTimeEdited: false,
        showTimeSlotNotSelectedError: false 
      });

      // Reset validation & warnings
      props.selectedTimeConflicted(false);
      this.setState({ showConflictValidationError: false });

      props.selectedTimeChanged(startTime, endTime);
    }
  }

  quartersRows(booking, bookings, reservations) {
    const { props, state } = this;
    const quartersRows = [];

    let [ openingHour, closingHour ] = [ null, null ];

    const overrideDate = props.overrideHours.find(o => Utils.datesAreOnSameDay(new Date(o.date), state.bookingDate) && (o.timeFrom && o.timeTo))
    if (overrideDate) {
      // There is override
      openingHour = parseInt(overrideDate.timeFrom, 10);
      closingHour = parseInt(overrideDate.timeTo, 10);
    } else {
      // Normal day, no overrides
      // Get day of week
      const dayOfWeek = state.bookingDate.getDay();
      
      // Get working hours, for that selected date
      const dayWorkingHours = props.workingHours[dayOfWeek];

      // get "opening" and "closing" values for that date
      openingHour = dayWorkingHours ? parseInt(dayWorkingHours.from, 10) : 0;
      closingHour = dayWorkingHours ? parseInt(dayWorkingHours.to, 10) : 0;
    }

    for (let i = openingHour; i < closingHour; i += 1) {
      quartersRows.push(
        <QuartersRow
          date={this.buildWhenDate(i)}
          bookings={bookings}
          reservations={reservations}
          key={props.getKey()}
          getKey={props.getKey}
          selectedTimeChanged={this.selectedTimeChanged}
          booking={booking}
          capacity={parseInt(props.capacityLimit, 10)}
          amountPeople={parseInt(booking.amountPeople + booking.amountPeopleKids, 10)}
          addCapacityWarning={this.showConflictValidationError}
        />
      );
    }

    return quartersRows;
  }

  buildWhenDate(hourNo, minuteNo) {
    const { state } = this
    const date = new Date(state.bookingDate)
    date.setHours(hourNo || 0, minuteNo || 0, 0, 0)
    return date
  }

  showConflictValidationError() {
    const { props, state } = this;
    if (!state.showConflictValidationError) {
      this.setState({ showConflictValidationError: true });
      props.selectedTimeConflicted(true);
    }
  }

  async fetchBookingOverview(startTime) {
    this.setState({ isLoading: true });
    const endTime = new Date(startTime);
    endTime.setDate(startTime.getDate() + 1);
    
    const formattedDateStart = Utils.dateEquivalentInCPH(startTime).toISOString()
    const formattedDateEnd = Utils.dateEquivalentInCPH(endTime).toISOString()

    const { booking } = this.props;
    const uuid = booking.reservation ? booking.reservation.uuid : "";

    const [bookings, reservations] = await Promise.all([
      API.get(
        "cphill",
        `/bookings?date-start=${formattedDateStart}&date-end=${formattedDateEnd}`,
        {}
      ),
      API.get(
        "cphill",
        `/reservations?date-start=${formattedDateStart}&date-end=${formattedDateEnd}${uuid &&
          `&uuid=${uuid}`}`,
        {}
      )
    ]);
    this.setState({ bookings, reservations, isLoading: false });
  }

  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  isClosedDay(date) {
    const { overrideHours } = this.props
    return !(overrideHours.filter(day => day.isClosed && new Date(day.date).setHours(0,0,0,0) === new Date(date).setHours(0,0,0,0))
      .length > 0)
  }
  

  isFutureDay(date){
    const { futureBookingLimit } = this.props
    return date > this.addDays(new Date(), Number(futureBookingLimit))
  }

  updateHoursAndClearSlot(increase) {
    const { props, state, } = this
    const { hoursCount } = state
    this.setState({ 
      hoursCount: increase ? hoursCount+1 : hoursCount-1, 
      selectedTimeEdited: true 
    })
    props.selectedTimeChanged(null, null)
  }

  handleHoursCountChange(e, increase) {
    const { hoursCount } = this.state
    if(increase){
      return hoursCount < 4 ? this.updateHoursAndClearSlot(true) : null
    }
      return hoursCount > 1 ? this.updateHoursAndClearSlot(false) : null
  }

  renderDayContents(day, date) {
    const { intl } = this.props
    
    // eslint-disable-next-line no-nested-ternary
    const tooltipText = !this.isClosedDay(date) ? intl.formatMessage({id: 'booking.whenForm.pickertooltip.closed'}) : 
      this.isFutureDay(date) ? intl.formatMessage({id: 'booking.whenForm.pickertooltip.futurelimit'}) : ""
    
    
      return <span title={tooltipText}>{date.getDate()}</span>
  }


  render() {
    const { props, state } = this;
    const { showDateNotSelectedError, disableDurationSelection, intl } = props
    const { hoursCount, selectedTimeEdited, showOutOfTimeBoundsError } = state
    
    return (
      <>
        <div className="container mx-auto px-2 md:px-0">
          <div className="lg:w-2/3 xl:w-3/5 mb-12 mx-auto">
            <CSSTransition {...TransitionStyles} transitionAppear active>
              {/* <div className="flex items-center bg-sky-80 text-white text-sm px-4 py-3">
                  <svg className="fill-current w-6 h-6 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" /></svg>
                  <div>
                    <strong>OBS:</strong>
                    . Pt. kan du kun booke til tirsdag og onsdag i uge 7, hvor vi holder særligt åbent. 
                  </div>
                </div> */}

              <div className="flex flex-wrap py-4 pb-8 border-b">
                <h2 className="flex-grow self-center mt-6">
                  <FormattedMessage
                    id="booking.whenForm.chooseDate"
                    defaultMessage="Choose date"
                  />
                </h2>

                <div className="self-center mt-6">
                  <DatePicker 
                    className={`rounded-full appearance-none border border-grey hover:border-grey-darkest rounded w-64 py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-blue ${showDateNotSelectedError ? "border-red" : null}`}
                    placeholderText={intl.formatMessage({id: 'booking.whenForm.datepickerplaceholder', defaultMessage: 'Click to select a date'})}
                    dateFormat="dd/MM/yyyy"
                    selected={state.bookingDate} 
                    onChange={date => this.handleDateChange(date)} 
                    minDate={new Date()}
                    maxDate={this.addDays(new Date(), Number(props.futureBookingLimit))}
                    filterDate={this.isClosedDay}
                    withPortal
                    renderDayContents={this.renderDayContents}
                    customInput={<DatepickerInput />}
                    locale={intl.locale === "da" ? da : enGB}
                    // dayClassName={date => date.getDate() === (new Date()).getDate() && !this.state.selectedTimeEdited ? 'selected-day-class' : undefined}
                  />
                  {state.showDateValidationError && (
                    <CSSTransition
                      {...TransitionStyles}
                      transitionAppear
                      active
                    >
                      <div
                        className="text-sm mt-4 bg-red-lightest border-l-2 border-red text-red-dark p-2"
                        role="alert"
                      >
                        <p className="font-bold m-0">
                          <FormattedMessage
                            id="booking.whenForm.warningPastHeader"
                            defaultMessage="It's in the past"
                          />
                        </p>
                        <p className="m-0">
                          <FormattedMessage
                            id="booking.whenForm.warningPastText"
                            defaultMessage="You have selected a day that has already been"
                          />
                        </p>
                      </div>
                    </CSSTransition>
                  )}
                  {state.showDayClosedError && (
                    <CSSTransition
                      {...TransitionStyles}
                      transitionAppear
                      active
                    >
                      <div
                        className="text-sm mt-4 bg-red-lightest border-l-2 border-red text-red-dark p-2"
                        role="alert"
                      >
                        <p className="font-bold m-0">
                          <FormattedMessage
                            id="booking.whenForm.warningDayClosedHeader"
                            defaultMessage="Day is closed"
                          />
                        </p>
                        <p className="m-0">
                          <FormattedMessage
                            id="booking.whenForm.warningDayClosedText"
                            defaultMessage="You have selected a day that is closed"
                          />
                        </p>
                      </div>
                    </CSSTransition>
                  )}
                  {/* {state.showExceedFutureLimitError && (
                    <CSSTransition
                      {...TransitionStyles}
                      transitionAppear
                      active
                    >
                      <div
                        className="text-sm mt-4 bg-red-lightest border-l-2 border-red text-red-dark p-2"
                        role="alert"
                      >
                        <p className="font-bold m-0">
                          <FormattedMessage
                            id="booking.whenForm.warningFutureLimitExccedHeader"
                            defaultMessage="Future Limit"
                          />
                        </p>
                        <p className="m-0">
                          <FormattedMessage
                            id="booking.whenForm.warningFutureLimit.line1"
                            defaultMessage="Booking more than"
                          />
                          {` ${futureBookingLimit} `}
                          <FormattedMessage
                            id="booking.whenForm.warningFutureLimit.line2"
                            defaultMessage="days in future not possible"
                          />
                        </p>
                      </div>
                    </CSSTransition>
                  )} */}
                </div>
              </div>
            </CSSTransition>

            {state.bookingDate && !disableDurationSelection && (
              <CSSTransition {...TransitionStyles} transitionAppear active>
                <div className="flex py-8 border-b">
                  <div className="flex flex-col">
                    <h2>
                      <FormattedMessage
                        id="booking.whenForm.chooseHours"
                        defaultMessage="Select hours per person"
                      />
                    </h2>
                    <div className="text-sky items-center text-xs font-bold mt-4">
                      <FormattedMessage
                        id="booking.whenForm.3hoursdiscount"
                        defaultMessage="Book 3 hours and receive a discount"
                      />
                    </div>
                  </div>
                  

                  <div className="w-3/4">
                    <div className="flex flex-col items-center">
                      <div className="text-sky items-center text-xs font-bold mt-8">
                        <FormattedMessage
                          id="booking.whenForm.labelHours"
                          defaultMessage="Hours"
                        />
                      </div>
                      <div className="flex flex-row">
                        <button
                          name="hoursCount"
                          className="focus:outline-none text-grey-dark hover:border-grey-darkest font-semibold p-3 w-10 h-10 text-sm hover:text-grey-darkest border border-grey rounded-full mr-2"
                          style={{ touchAction: 'manipulation' }}
                          onClick={(e) => this.handleHoursCountChange(e, false)}
                          type="button"
                        >
                          -
                        </button>
                        <div className="py-2 px-8 border border-grey no-underline rounded-full bg-transparent text-black font-sans font-semibold text-sm mr-2">
                          {hoursCount}
                        </div>
                        <button
                          name="hoursCount"
                          className="focus:outline-none text-grey-dark hover:border-grey-darkest font-semibold p-3 w-10 h-10 text-sm hover:text-grey-darkest border border-grey rounded-full"
                          style={{ touchAction: 'manipulation' }}
                          onClick={(e) => this.handleHoursCountChange(e, true)}
                          type="button"
                        >
                        +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </CSSTransition>
            )}

            {state.bookingDate &&
              state.hoursCount && (
                <CSSTransition {...TransitionStyles} transitionAppear active>
                  <div className="relative py-4">
                    <h2>
                      <FormattedMessage
                        id="booking.whenForm.startingTime"
                        defaultMessage="Select starting time"
                      />
                    </h2>
                    {state.isLoading ? (
                      <Spinner />
                    ) : (
                      <>
                        {props.booking &&
                          state.bookings &&
                          this.quartersRows(
                            props.booking,
                            state.bookings,
                            state.reservations,
                            props.workingHours
                          )}
                      </>
                    )}
                  </div>
                </CSSTransition>
              )}
          </div>
        </div>

        <CSSTransition {...TransitionStyles} transitionAppear active>
          <div className="container mx-auto md:w-3/4 lg:w-2/3">
            
            {props.booking.whenStartTime && 
              !selectedTimeEdited && 
              !showOutOfTimeBoundsError && (
                <div className="mt-8 py-10 text-center shadow-md">
                  <h4 className="font-bold text-sky uppercase">
                    <FormattedMessage
                      id="booking.whenForm.summaryTitle"
                      defaultMessage="You've selected"
                    />
                  </h4>
                  <h1>
                    <FormattedDate
                      value={props.booking.whenStartTime}
                      year="numeric"
                      month="long"
                      day="numeric"
                    />
                  </h1>
                  <h3>
                    <FormattedTime value={props.booking.whenStartTime} />
                    &nbsp;-&nbsp;
                    <FormattedTime value={props.booking.whenEndTime} />
                  </h3>
                </div>
            
          )}

            {state.showConflictValidationError && (
              <CSSTransition {...TransitionStyles} transitionAppear active>
                <div
                  className="text-sm mt-4 bg-red-lightest border-l-2 border-red text-red-dark p-2"
                  role="alert"
                >
                  <p className="font-bold m-0">
                    <FormattedMessage
                      id="booking.whenForm.warningCapacityHeader"
                      defaultMessage="Facility full"
                    />
                  </p>
                  <p className="m-0">
                    <FormattedMessage
                      id="booking.whenForm.warningCapacityText"
                      defaultMessage="You have select a timeslot where the facility is at capacity"
                    />
                  </p>
                </div>
              </CSSTransition>
            )}

            {state.showOutOfTimeBoundsError && (
              <CSSTransition {...TransitionStyles} transitionAppear active>
                <div
                  className="text-sm mt-4 bg-red-lightest border-l-2 border-red text-red-dark p-2"
                  role="alert"
                >
                  <p className="font-bold m-0">
                    <FormattedMessage
                      id="booking.whenForm.warningOutOfTimeBoundsHeader"
                      defaultMessage="Out of time bounds"
                    />
                  </p>
                  <p className="m-0">
                    <FormattedMessage
                      id="booking.whenForm.warningOutOfTimeBoundsText"
                      defaultMessage="Your end time is after the facility has closed"
                    />
                  </p>
                </div>
              </CSSTransition>
            )}
            {state.showTimeSlotNotSelectedError && (
              <CSSTransition {...TransitionStyles} transitionAppear active>
                <div
                  className="text-sm mt-4 bg-red-lightest border-l-2 border-red text-red-dark p-2"
                  role="alert"
                >
                  <p className="font-bold m-0">
                    <FormattedMessage
                      id="booking.whenForm.warning.SelectTimeSlotTitle"
                      defaultMessage="Missing fields"
                    />
                  </p>
                  <p className="m-0">
                    <FormattedMessage
                      id="booking.whenForm.warning.SelectTimeSlot"
                      defaultMessage="Choose when you want to visit"
                    />
                  </p>
                </div>
              </CSSTransition>
            )}
          </div>
        </CSSTransition>
      </>
    );
  }
}

TimeSlotSelector.propTypes = {
  booking: PropTypes.shape({ booking: PropTypes.object }).isRequired,
  getKey: PropTypes.func.isRequired,
  selectedTimeChanged: PropTypes.func.isRequired,
  selectedTimeConflicted: PropTypes.func.isRequired,
  disableDurationSelection: PropTypes.bool
};

TimeSlotSelector.defaultProps = {
  disableDurationSelection: false
};

export default injectIntl(TimeSlotSelector);
